var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeller(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 238.93 68.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Keller Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Diamond"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34,51,17,34h0c3.59,11,0,34,0,34Z",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,36.06,0,51,13.31,64.33A55.37,55.37,0,0,0,15,36.06",
    fill: "#fdc600"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Diamond-2",
    "data-name": "Diamond"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34,17,17,0h0c3.59,11.05,0,34,0,34Z",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,2.05,0,17l13.31,13.3A55.33,55.33,0,0,0,15,2.05",
    fill: "#fdc600"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "E",
    points: "85.71 17.01 113.27 17.01 113.27 24.81 95.87 24.81 95.87 30.06 110.17 30.06 110.17 37.41 95.87 37.41 95.87 43.22 114.48 43.22 114.48 51.02 85.71 51.02 85.71 17.01",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "L",
    points: "116.89 17.01 127.06 17.01 127.06 43.07 144.11 43.07 144.11 51.02 116.89 51.02 116.89 17.01",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "L-2",
    "data-name": "L",
    points: "146.53 17.01 156.69 17.01 156.69 43.07 173.75 43.07 173.75 51.02 146.53 51.02 146.53 17.01",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "E-2",
    "data-name": "E",
    points: "176.16 17.01 203.73 17.01 203.73 24.81 186.33 24.81 186.33 30.06 200.63 30.06 200.63 37.41 186.33 37.41 186.33 43.22 204.93 43.22 204.93 51.02 176.16 51.02 176.16 17.01",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("path", {
    id: "R",
    d: "M222.22,32.36a4.8,4.8,0,0,0,3.28-1.1,3.69,3.69,0,0,0,1.26-2.93,4,4,0,0,0-1.21-3.07,4.85,4.85,0,0,0-3.38-1.11h-4.89v8.21ZM207.34,17H223.2a20.54,20.54,0,0,1,5.59.71,12.35,12.35,0,0,1,4.28,2.12,9.44,9.44,0,0,1,2.76,3.49,11.35,11.35,0,0,1,1,4.85A10.19,10.19,0,0,1,235.14,34a12,12,0,0,1-4.42,4L238.93,51H228l-6.49-11.57h-4.25V51h-9.94Z",
    fill: "#036"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "K",
    points: "84.5 17.01 71.56 17.01 60.96 27.61 60.96 17.01 51.03 17.01 51.03 51.02 60.96 51.02 60.96 40.43 71.56 51.02 84.5 51.02 67.49 34.02 84.5 17.01",
    fill: "#036"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeller);
export default __webpack_public_path__ + "static/media/keller.59ca9a0af8a0c41c27a93f15afb9285f.svg";
export { ForwardRef as ReactComponent };